"use strict";

import module from "./module.js";

export default module;
